import { Input } from "@fluentui/react-components";
import PropTypes from "prop-types";

const EditableNumericCell = ({ dataItem, field, onChange }) => {
  const handleChange = (e) => {
    const inputValue = Number(e.target.value);
    onChange({
      dataItem,
      field,
      value: inputValue < 0 ? 0 : inputValue,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "." || e.key === ",") {
      e.preventDefault();
    }
  };

  return (
    <td className="background-white k-table-td">
      <Input
        type="number"
        min={0}
        step="1"
        value={
          dataItem[field] === null || dataItem[field] === undefined || dataItem[field] === ''
            ? ''
            : Number(dataItem[field])
        }
        placeholder="-"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        appearance="outline"
        style={{
          width: "100%",
          boxSizing: "border-box",
        }}
      />
    </td>
  );
};

EditableNumericCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default EditableNumericCell;
